var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$userCan("fav_list")
    ? _c(
        "b-modal",
        {
          attrs: {
            id: "favouriteTag",
            title: "Add to list",
            "ok-only": "",
            "no-fade": ""
          },
          on: {
            change: _vm.onModalChange,
            hide: _vm.onModalChange,
            show: _vm.onModalChange
          },
          scopedSlots: _vm._u(
            [
              {
                key: "modal-ok",
                fn: function() {
                  return [_vm._v("\n        Close\n    ")]
                },
                proxy: true
              }
            ],
            null,
            false,
            2492338953
          ),
          model: {
            value: _vm.modalOpen,
            callback: function($$v) {
              _vm.modalOpen = $$v
            },
            expression: "modalOpen"
          }
        },
        [
          _vm._v(" "),
          _c("div", { on: { keydown: _vm.onKeyDown } }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c(
                  "ul",
                  { staticClass: "favourite-tags" },
                  _vm._l(_vm.tags, function(item, i) {
                    return _c("li", [
                      _c(
                        "span",
                        {
                          staticClass: "tag-name",
                          class: _vm.isVehicleAdded(item.vehicles)
                            ? "active"
                            : "",
                          attrs: {
                            title:
                              i > 8
                                ? ""
                                : "Press " +
                                  (i + 1) +
                                  " to quickly add to list and close popup."
                          },
                          on: {
                            click: function($event) {
                              return _vm.toggleMapping(item, $event)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(i + 1) +
                              ". " +
                              _vm._s(item.name) +
                              "\n                        "
                          )
                        ]
                      )
                    ])
                  }),
                  0
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row create-new-tag" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.tag_name,
                    expression: "tag_name"
                  }
                ],
                ref: "tag_name",
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "tag_name",
                  placeholder: "List Name"
                },
                domProps: { value: _vm.tag_name },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.tag_name = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn btn-primary",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.addNewFavoriteTag()
                    }
                  }
                },
                [_vm._v("Create new")]
              )
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f4c193be", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4c193be","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/FavouriteTagModal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-f4c193be","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/FavouriteTagModal.vue
// module chunks = 0